"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSchema = exports.registerSchema = exports.loginSchema = void 0;
const zod_1 = require("zod");
// API verbatim schemas (source of truth: apps/api/src/common/schemas.ts)
exports.loginSchema = zod_1.z.object({
    email: zod_1.z.string().email("Geçerli bir e-posta giriniz"),
    password: zod_1.z.string().min(1, "Şifre zorunludur"),
});
exports.registerSchema = zod_1.z.object({
    name: zod_1.z.string().min(2, "İsim en az 2 karakter olmalıdır"),
    email: zod_1.z.string().email("Geçerli bir e-posta giriniz"),
    password: zod_1.z
        .string()
        .min(8, "Şifre en az 8 karakter olmalıdır")
        .regex(/[A-Z]/, "Şifre en az bir büyük harf içermelidir")
        .regex(/[a-z]/, "Şifre en az bir küçük harf içermelidir")
        .regex(/[0-9]/, "Şifre en az bir rakam içermelidir")
        .regex(/[^A-Za-z0-9]/, "Şifre en az bir özel karakter içermelidir"),
});
// Full DB row schema for the User model
exports.userSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    email: zod_1.z.string().email(),
    role: zod_1.z.enum(["admin", "editor"]).default("editor"),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
//# sourceMappingURL=auth.js.map